module.exports = __webpack_public_path__ + "img/gastos.7dc9a892.jpeg";